import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from "../../../sessionStorage";

export const PRODUCT_URLS = {
    TERM: "/landing/term-insurance",
    FE: "/landing/final-expense",
    WL: "/landing/whole-life",
    UL: "/landing/universal-life",
    BS: "/landing/business-solutions",
}

export const getActiveQuestionList = (productUrl) => {
    const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
    const productDetails = accountObj?.accountProducts?.find(product => product.productLandingUrl === productUrl);
    const questionData = productDetails?.configurableQuestions ? JSON.parse(productDetails.configurableQuestions) : [];
    const activeQuestionList = questionData.filter(q => q.active);
    return activeQuestionList || [];
}
